var React = require('react');

function LongArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.39645 119.854C3.59171 120.049 3.90829 120.049 4.10355 119.854L7.28553 116.672C7.4808 116.476 7.4808 116.16 7.28553 115.964C7.09027 115.769 6.77369 115.769 6.57843 115.964L3.75 118.793L0.921573 115.964C0.726311 115.769 0.409728 115.769 0.214466 115.964C0.0192039 116.16 0.0192039 116.476 0.214466 116.672L3.39645 119.854ZM3.25 0V119.5H4.25V0H3.25Z","fill":"#CFD8DC"}));
}

LongArrowInline.defaultProps = {"width":"8","height":"120","viewBox":"0 0 8 120","fill":"none"};

module.exports = LongArrowInline;

LongArrowInline.default = LongArrowInline;
